import React, { useEffect, useState } from "react";
import PropTypes from "kf-proptypes/widgets";

import styles from "./styles.css";

const PLACEHOLDER_SIZE = {
  "8-x-8": 8,
  "12-x-12": 12,
  "16-x-16": 16,
  "20-x-20": 20,
  "24-x-24": 24,
  "28-x-28": 28,
  "32-x-32": 32,
  "40-x-40": 40
};

/**
 * @description This components loads an empty placeholder for the kficon usually this component loads when the fetch is
 * happening or the request url for the icon gets failed
 * @param {string} size - The size of the placeholder icon usually it will be actual size of the requested KF Icon
 * @param {string} color - The color of the placeholder icon usually it will be actual color of the requested KF Icon
 * @returns - Placeholder icon component
 */
export function PlaceholderIcon({
  size,
  color = "--kf-color-gray-300",
  className
}) {
  const [iconSize, setIconSize] = useState("");

  useEffect(
    function onSizeChange() {
      setIconSize(PLACEHOLDER_SIZE[size] || 12);
    },
    [size]
  );

  return (
    <span
      className={`${styles.placeholderIcon} ${className}`}
      style={{
        height: `${iconSize}px`,
        width: `${iconSize}px`,
        display: "flex"
      }}
    >
      {/* <svg
        height={iconSize}
        width={iconSize}
        viewbox={`0 0 ${iconSize} ${iconSize}`}
      >
        <circle
          cx={iconSize / 2}
          cy={iconSize / 2}
          r={iconSize / 2}
          fill={color}
        />
      </svg> */}
      &nbsp;
    </span>
  );
}

PlaceholderIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string
};
